import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import * as React from 'react';
import { View } from 'react-native';
import Svg, { Path, Rect } from 'react-native-svg';
var FailToLoad = function FailToLoad(props) {
  return /*#__PURE__*/React.createElement(View, {
    style: _objectSpread({
      width: 50,
      height: 50
    }, props.style)
  }, /*#__PURE__*/React.createElement(Svg, {
    height: "100%",
    width: "100%",
    viewBox: "0 0 32 33",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#E8E8E8",
    d: "M9.712 31.87H5.444a2 2 0 0 1-2-2V5.446a2 2 0 0 1 2-2h13.549c.351 0 .689.134.944.376l6.496 6.153c.277.262.434.627.434 1.01v19.064a2 2 0 0 1-2.024 2l-15.131-.177Z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#BDBDBD",
    fillRule: "evenodd",
    d: "M1 30.311a1 1 0 0 1-1-1V2a2 2 0 0 1 2-2h13.537c.413 0 .81.16 1.11.448l7.643 7.306c.326.311.51.745.51 1.198v19.36a2 2 0 0 1-2 2H1ZM15.906 1.397l-.021-.02H2.378a1 1 0 0 0-1 1v25.557a1 1 0 0 0 1 1h20.044a1 1 0 0 0 1-1v-18.3h-6.208c-.746 0-1.308-.679-1.308-1.378V1.397Zm1.308 1.246V7.27a1 1 0 0 0 .987 1l4.992.066-5.979-5.692Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    d: "M24.111 31.689a6.889 6.889 0 1 0 0-13.778 6.889 6.889 0 0 0 0 13.778Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 6.889,
    height: 1.378,
    x: 3.444,
    y: 8.267,
    fill: "#BDBDBD",
    rx: 0.689
  }), /*#__PURE__*/React.createElement(Rect, {
    width: 9.644,
    height: 1.378,
    x: 3.444,
    y: 12.4,
    fill: "#BDBDBD",
    rx: 0.689
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m22.044 22.733 4.134 4.134M26.178 22.733l-3.875 4.134"
  })));
};
export default FailToLoad;